"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNestedTableField = void 0;
const nested_table_field_1 = require("../../../components/nested-table-field/nested-table-field");
const form_field_1 = require("./form-field");
exports.FormNestedTableField = (0, form_field_1.formFieldFactory)(nested_table_field_1.NestedTableField);
//# sourceMappingURL=form-nested-table-field.js.map